export default [
  {
    path: '/permission',
    name: 'permission',
    component: () => import('@/views/permission/Permission.vue'),
    meta: {
      title: 'Permissions',
      requiresAuth: true,
    },
  },
]
